export default __webpack_public_path__ + "static/media/icon-info.d501e256.svg";